var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7079 3.3335C7.02785 3.3335 4.04785 6.32016 4.04785 10.0002C4.04785 13.6802 7.02785 16.6668 10.7079 16.6668C14.3945 16.6668 17.3812 13.6802 17.3812 10.0002C17.3812 6.32016 14.3945 3.3335 10.7079 3.3335ZM13.3812 12.6668C13.1212 12.9268 12.7012 12.9268 12.4412 12.6668L10.2479 10.4735C10.1212 10.3468 10.0479 10.1802 10.0479 10.0002V7.3335C10.0479 6.96683 10.3479 6.66683 10.7145 6.66683C11.0812 6.66683 11.3812 6.96683 11.3812 7.3335V9.72683L13.3812 11.7268C13.6412 11.9868 13.6412 12.4068 13.3812 12.6668Z",
    fill: "#CF9F02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.045a49ab3403912425dddf243f4b85fc.svg";
export { ForwardRef as ReactComponent };